import styled from 'styled-components';

export const OnDeviceSensorTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .footer {
    align-self: flex-end;
    padding-right: ${({ theme: { token } }) => token.padding}px;
    padding-bottom: ${({ theme: { token } }) => token.padding}px;
  }

  .body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: ${({ theme: { token } }) => token.margin}px;
    padding: 0 ${({ theme: { token } }) => token.padding}px;
  }

  .sensor-form {
    padding: ${({ theme: { token } }) => token.padding}px;
  }

  .divider {
    margin: ${({ theme: { token } }) => token.margin}px 0;
  }
`;
